<template>
  <v-container fluid hei>
    <v-row align="center" justify="center" class="mx-0">
      <v-col cols="12">
        <v-card outlined height="75vh">
          <v-card-title>
            <div class="text-h5">EventConnect</div>
          </v-card-title>
          <v-card-text
            class="d-flex justify-center align-center flex-column fill-height"
          >
            <v-icon size="60" class="mb-4">mdi-account-group</v-icon>
            <div class="text-h6 font-weight-medium mb-3">
              Organise your events with EventConnect
            </div>
            <div class="mb-2 text-center">
              If you are organising an online or physical event, <br />
              EventConnect helps your event attendees connect <br />
              with each other seamlessly.
            </div>

            <div
              class="mb-5 text-center cursor-pointer primary--text"
              @click="showMultiConnectVideo = true"
            >
              Watch video
            </div>

            <v-btn
              color="primary"
              width="300"
              depressed
              @click="showAddToPlanDialog = true"
              >Add EventConnect to plan</v-btn
            >
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <MultiConnectVideo
      :show="showMultiConnectVideo"
      @close="showMultiConnectVideo = false"
    />

    <AddInclusionToPlanDialog
      :show="showAddToPlanDialog"
      :selectedInclusion="multiConnectInclusion"
      @close="showAddToPlanDialog = false"
    />
  </v-container>
</template>

<script>
import MultiConnectVideo from "@/components/MultiConnect/MultiConnectVideo";
import AddInclusionToPlanDialog from "@/components/ManageSubscription/AddInclusionToPlanDialog";

export default {
  components: {
    MultiConnectVideo,
    AddInclusionToPlanDialog,
  },
  data() {
    return {
      showMultiConnectVideo: false,
      showAddToPlanDialog: false,
      multiConnectInclusion: {
        name: "EventConnect",
      },
    };
  },
};
</script>

<style></style>
